module.exports = __webpack_public_path__ + "components/icon/static/list-7597cc3dbce72a2d3add97d67094cd72.svg";